import { Link } from "react-router-dom";
import { ChevronRight, ArrowRight } from "lucide-react";
import { Reveal, Counter } from "../components/Reveal";

export default function About() {
  return (
    <div data-testid="about-page" className="pt-32 pb-24 bg-[#FAFAFA]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-2 text-[11px] tracking-widest uppercase text-[#888] mb-8">
          <Link to="/" className="hover:text-[#B8860B]">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <span className="text-[#1E1E1E]">Kurumsal</span>
        </div>

        <div className="mb-16 max-w-4xl">
          <div className="text-[10px] tracking-[0.35em] uppercase text-[#B8860B] mb-4">
            Hakkımızda
          </div>
          <h1 className="font-serif-display text-4xl md:text-6xl lg:text-7xl text-[#1E1E1E] leading-tight">
            Yüzeylerin arkasındaki hikâye.
          </h1>
        </div>

        <div className="grid lg:grid-cols-12 gap-16 items-start mb-24">
          <div className="lg:col-span-7">
            <div className="clip-frame aspect-[4/3] overflow-hidden">
              <img src="/catalog/vesna-hero.jpg" alt="SeraPark Showroom" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-5 space-y-6 text-[15px] text-[#555] leading-[1.9]">
            <p>SeraPark, 2007'de Şanlıurfa'da kurulan; premium seramik, porselen ve yapı malzemelerini tek çatı altında buluşturan bir kürasyon atölyesidir.</p>
            <p>17 yıllık deneyimimizle Türkiye'nin dört bir yanında 520'yi aşkın referans projede imzamız var. İtalyan, İspanyol ve seçili Türk üreticilerin ürünlerini bir mimari gözüyle seçiyor; her koleksiyonu üç aşamalı bir kalite kontrolünden geçiriyoruz.</p>
            <p>Amacımız yalnızca ürün satmak değil; müşterilerimizin mekânlarına yıllarca hizmet edecek yüzeyleri onlarla birlikte seçmek.</p>
          </div>
        </div>

        <div id="misyon" className="grid lg:grid-cols-3 gap-6 md:gap-10 mb-24">
          {[
            { n: "01", t: "Misyon", d: "Zamansız kaliteye sahip yüzeyleri, mimari çözüm ortaklığıyla müşterilerimize sunmak; endüstrimizin standartlarını yükseltmek." },
            { n: "02", t: "Vizyon", d: "Türkiye'nin premium seramik kürasyonunda ilk akla gelen adresi olmak; komşu ülkelerde de referans showroom deneyimi inşa etmek." },
            { n: "03", t: "Kalite Politikası", d: "Ürün seçiminde uluslararası standartlar (EN 14411, ISO 13006) aranır; müşteriye ulaşmadan önce her koleksiyon showroom'da test edilir." },
          ].map((c) => (
            <Reveal key={c.n}>
              <div id={c.t.toLowerCase()} className="p-10 bg-white border border-black/5 h-full">
                <div className="font-serif-display text-5xl text-[#B8860B]">{c.n}</div>
                <h3 className="mt-6 font-serif-display text-2xl text-[#1E1E1E]">{c.t}</h3>
                <p className="mt-4 text-[14px] text-[#666] leading-relaxed">{c.d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div id="kalite" className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 py-16 border-y border-black/8">
          {[
            { v: 17, s: "+", l: "Yıl Deneyim" },
            { v: 8000, s: "", l: "m² Showroom" },
            { v: 520, s: "+", l: "Referans Proje" },
            { v: 40, s: "+", l: "Marka" },
          ].map((k) => (
            <div key={k.l} className="text-center md:text-left">
              <div className="font-serif-display text-5xl md:text-6xl text-[#1E1E1E]">
                <Counter to={k.v} suffix={k.s} />
              </div>
              <div className="mt-2 text-[10px] tracking-[0.3em] uppercase text-[#888]">{k.l}</div>
            </div>
          ))}
        </div>

        <div className="mt-24 text-center">
          <h2 className="font-serif-display text-3xl md:text-5xl text-[#1E1E1E]">
            Showroom'umuza bekleriz.
          </h2>
          <div className="mt-8 flex justify-center gap-3 flex-wrap">
            <Link to="/iletisim" className="btn-gold">Bize Ulaşın <ArrowRight size={14} /></Link>
            <Link to="/projeler" className="btn-ghost">Projelerimizi İnceleyin</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
